/**
 * localStorage 缓存与偏好。
 * 数据缓存带版本号（v3）：DTO 结构变化时改变版本，旧缓存自动失效。
 */
import type { MatchDto } from '../api';

export interface DayData {
  matches: MatchDto[];
  statusCounts: Record<string, number>;
}

export type StatusFilter = 'all' | 'live' | 'scheduled' | 'finished';
export type SortMode = 'time' | 'league';

export interface UiPrefs {
  statusFilter: StatusFilter;
  sortMode: SortMode;
  oddsView: 'compare' | 'william' | 'ladbrokes';
  leagueFilter: string;
}

export const DEFAULT_PREFS: UiPrefs = { statusFilter: 'all', sortMode: 'time', oddsView: 'compare', leagueFilter: 'all' };

const DAY_CACHE_PREFIX = 'nowscore_day_cache_v3_';
const PREFS_KEY = 'nowscore_ui_prefs_v1';

export function readDayCache(date: string): DayData | null {
  try {
    const raw = localStorage.getItem(DAY_CACHE_PREFIX + date);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<DayData>;
    return Array.isArray(parsed.matches) && parsed.statusCounts
      ? { matches: parsed.matches, statusCounts: parsed.statusCounts }
      : null;
  } catch {
    return null;
  }
}

export function writeDayCache(date: string, data: DayData): void {
  try {
    localStorage.setItem(DAY_CACHE_PREFIX + date, JSON.stringify({ ...data, cachedAt: Date.now() }));
  } catch {
    /* 存储不可用时忽略（隐私模式） */
  }
}

export function readPrefs(): UiPrefs {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw) as Partial<UiPrefs>;
    return { ...DEFAULT_PREFS, ...parsed };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function writePrefs(prefs: Partial<UiPrefs>): void {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify({ ...readPrefs(), ...prefs }));
  } catch {
    /* 忽略 */
  }
}
